import { Box, Circle, Image, Text } from "@chakra-ui/react";


export default function TopicDetails({ id, image, title, files, quizzes, status, order, displayOrder, orderId }) {
    
    return (
        <Box
            d='flex'
            justifyContent='space-between'
            alignItems='center'
            width='100%'
            py='1rem'
            position='relative'
            px='1.5rem'
        >
            <Box d='flex' justifyContent='flex-start' alignItems='center' pointerEvents='none'>
                <Circle size='50px' mr='1.5rem' >
                    <Image
                        src={image}
                        fallbackSrc={"https://source.unsplash.com/random/800x600"}
                        width='100%'
                        height='100%'
                        objectFit='cover'
                        borderRadius='50%'
                    />
                </Circle>
                <Box
                    style={{ fontFamily: 'Mulish, sans-serif' }}
                    d='flex'
                    flexDir='column'
                    justifyContent='center'
                    alignItems='flex-start'
                    flexGrow='1'
                >
                    <Text fontWeight='700' fontSize={['8px', '12px', '16px', '16px']} color='#333333'>{title}</Text>
                    <Text fontWeight='400' fontSize={['8px', '11px', '13px', '13px']} color="#1B1A1AB2">{files} {files > 1 ? 'Files' : 'File'} | {quizzes} {quizzes > 1 ? 'Quizzes' : 'Quiz'}</Text>
                </Box>
            </Box>
            <Box
                width='80%'
                height='1px'
                bg='rgba(39, 36, 36, 0.2)'
                position='absolute'
                bottom='0'
                right='5'
            ></Box>
        </Box>
    )
}